export const HOST_API = process.env.REACT_APP_API_URL;
export const SALES_FORCE_API_URL = 'https://api-dev.mhalt.com/leads2/leaffilter';
export const SALES_FORCE_LOGIN_URL='https://login.salesforce.com/services/oauth2/token'
export const SALES_FORCE_GUTTER_URL='https://abc742-dev-ed.develop.my.salesforce.com/services/apexrest/api/GuttersAPI'
